import type BackOfficeConnector from "../data/backOfficeConnector";
import type EventBus from "../services/eventBus";
import { serializeFilters } from "../utils/filters";
import RepositoryBase from "./repositoryBase";
import type { IPagination } from "../data/types";
import type SentEmailMessageSearchRequest from "entities/sentEmailMessageSearchRequest";
import SentEmailMessagesTotalCountResponse from "entities/sentEmailMessagesTotalCountResponse";
import SentEmailMessage from "entities/sentEmailMessageResponse";

export default class EmailMessageRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  getAll(filters: SentEmailMessageSearchRequest, pagination: IPagination, abortSignal?: AbortSignal) {
    return this.callApi(
      api =>
        api
          .all("call_center")
          .all("sent_email_message_search")
          .postPagedEntities<SentEmailMessage>(
            { ...serializeFilters(filters, false), ...pagination },
            SentEmailMessage,
            abortSignal
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }

  totalCount(entity: SentEmailMessageSearchRequest) {
    return this.callApi(
      api =>
        api
          .all("call_center")
          .all("sent_email_message_search")
          .all("total_count")
          .postEntity<SentEmailMessagesTotalCountResponse>(
            { ...serializeFilters(entity, false) },
            SentEmailMessagesTotalCountResponse
          ),
      {
        ownApiFactory: () => this.apiFactory({ customVersion: "2" }),
      }
    );
  }
}
